import { gql } from "apollo-boost";
import { sortLocationsByName } from "../../helpers/locations";
import useCurrentUserStore from "../../store/userStore";
import { apolloClient, getApolloOptions } from "./apolloClient";

const GET_USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      email
      username
      confirmed
      client {
        id
        username
        first_name
        insertion
        last_name
        date_of_birth
        gender
        email
        email_verified
        address1
        address2
        zip_code
        place_name
        country
        phone_number
        registration_date
        points
        activation_token
        created_at
        updated_at
        teams {
          name
          score
          token
          register_token
          created_at
          updated_at
        }
      }
      role {
        id
        name
        type
      }
      locations {
        id
        name
        xcubes {
          id
        }
      }
    }
  }
`;

function getToken() {
    return localStorage.getItem("xcube-session-key");
}

function parseJwt() {
    const token = getToken();
    if (!token) return {};
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const repl = (c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`;
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(repl).join(""));
    return JSON.parse(jsonPayload);
}

export const fetchUserData = async () => {
    if (!getToken()) {
        return null;
    }
    const { id } = parseJwt();
    if (!id) {
        return null;
    }
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_USER,
        variables: { id },
    });
    const store = useCurrentUserStore();
    const user = { ...res.data.user, locations: sortLocationsByName(res.data.user.locations) };
    store.setCurrentUser(user);
    return user;
};
